import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

// Pages
import HomePage from './pages/HomePage';
import AdminPage from './pages/AdminPage';
import LoginPage from './pages/LoginPage';
import BlogPage from './pages/BlogPage';
import BlogPostPage from './pages/BlogPostPage';

// Components
import CustomCursor from './components/ui/CustomCursor';

// Context
import { AuthProvider, useAuth } from './components/AuthContext';

function App() {
  const ProtectedRoute = ({ children }) => {
    const { isAuthenticated, loading } = useAuth();

    if (loading) {
      return <div className="min-h-screen bg-gray-900 text-white flex items-center justify-center">Yükleniyor...</div>;
    }

    if (!isAuthenticated) {
      return <LoginPage />;
    }

    return children;
  };

  useEffect(() => {
    const smoothPageScroll = (e) => {
      if (e.target.tagName.toLowerCase() === 'a' && e.target.href) {
        const href = e.target.getAttribute('href');

        if (href && href.startsWith('#')) {
          e.preventDefault();
          const targetId = href.slice(1);
          const targetElement = document.getElementById(targetId);

          if (targetElement) {
            targetElement.scrollIntoView({
              behavior: 'smooth',
              block: 'start'
            });
          }
        }
      }
    };

    document.addEventListener('click', smoothPageScroll);

    return () => {
      document.removeEventListener('click', smoothPageScroll);
    };
  }, []);

  return (
    <Router>
      <AuthProvider>
        <div className="App">
          <CustomCursor />
          <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route path="/admin" element={
              <ProtectedRoute>
                <AdminPage />
              </ProtectedRoute>
            } />
            <Route path="/blog" element={<BlogPage />} />
            <Route path="/blog/:slug" element={<BlogPostPage />} />
            <Route path="*" element={<HomePage />} />
          </Routes>
        </div>
      </AuthProvider>
    </Router>
  );
}

export default App;
